import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import React, { useEffect, useState } from "react";

import { cn } from "@/lib/utils";

dayjs.extend(duration);

interface TimerProps {
  onClick?: () => void;
  onTimerEnd?: () => void;
  timerEnds: number | null;
}

type TimerVariant = "default" | "expires" | "end";

export const Timer: React.FC<TimerProps> = ({
  onClick,
  onTimerEnd,
  timerEnds,
}) => {
  const [secondsLeft, setSecondsLeft] = useState<number>(0);
  let variant: TimerVariant = "default";

  let timeText = timerEnds
    ? dayjs.duration(secondsLeft, "s").format("m:ss")
    : "--:--";

  if (timerEnds === null) {
    variant = "default";
    timeText = "--:--";
  } else if (secondsLeft <= 0) {
    variant = "end";
    timeText = "0:00";
  } else if (secondsLeft <= 10) {
    variant = "expires";
  }

  useEffect(() => {
    const setTimer = () => {
      if (timerEnds !== null) {
        const secondsLeft = Math.floor((timerEnds - dayjs().valueOf()) / 1000);

        if (secondsLeft === 0) {
          onTimerEnd?.();
        }

        setSecondsLeft(secondsLeft);
      }
    };

    setTimer();
    const counter = setInterval(() => {
      setTimer();
    }, 1000);

    return () => {
      clearInterval(counter);
    };
  }, [timerEnds, onTimerEnd]);

  return (
    <div
      className={cn(
        "flex items-center justify-center h-9 w-25 rounded-lg border-2 bg-background text-xl font-bold select-none",
        variant === "expires" &&
          "text-destructive border-destructive animate-timer-blink",
        variant === "end" && "bg-destructive text-background border-background",
        onClick && "cursor-pointer hover:opacity-70",
      )}
      onClick={onClick}
    >
      {timeText}
    </div>
  );
};
